export default "assets/images/48d0f42fa980663010b12859ea083359.png";